<div class="auto-ml-results">
  <app-top-stepper></app-top-stepper>
  <div class="auto-ml-results__main-heading">
    Selected variable you want to analyze <span>“{{_autoMl.dependentVariable}}”</span>
  </div>
  <div class="auto-ml-results__outer">
    <div class="auto-ml-results__left-sec">
      <div class="auto-ml-results__left-inner">
        <div *ngFor="let iterate of iterationSet;let iterateIndex=index;" class="auto-ml-results__tile" [ngClass]="{'expand': _autoMl.iterationSet[iterateIndex].isOpen}" >
          <div class="auto-ml-results__itration-head">
            <div class="auto-ml-results__itration-head-inner">
              <div class="auto-selected-tooltip">
                <span *ngIf="!iterate.isNameEdit" >{{iterate.name}} </span> 
                <div *ngIf="iterate.name.length>25"  class="auto-ml-results__tooltip"> {{iterate.name}} </div>
              </div>
              <input (click)="$event.stopPropagation()" *ngIf="iterate.isNameEdit" type="text" [(ngModel)]="iterate.name" maxlength="100" (change)="_autoMl.iterationSet[iterateIndex].isNameEdit = false; renameIterate(iterate.uuid,iterate.name)">
            </div>
            <div class="auto-ml-results__itration-btns-wrap">
              <div *ngIf="!iterate.isNameEdit && iterate.uuid !==''" (click)="_autoMl.iterationSet[iterateIndex].isNameEdit = true;" class="auto-ml-results__itration-icon">
                <img
                  src="assets/images/svg/edit-icon-black.svg"
                  alt=""
                />
              </div>
              <div (click)="deleteIteration(iterate.uuid,iterateIndex)" *ngIf="_autoMl.iterationSet.length>1" class="auto-ml-results__itration-icon delete">
                <img
                  src="assets/images/svg/delete-icon-black.svg"
                  alt=""
                />
              </div>
              <img  (click)="_autoMl.iterationSet[iterateIndex].isOpen = !_autoMl.iterationSet[iterateIndex].isOpen"
                src="assets/images/svg/arrow.svg"
                alt=""
                class="auto-ml-results__downarrow"
              />
            </div>
          </div>
          <div class="auto-ml-results__accuracy-wrap">
            Accuracy
            <div class="auto-ml-results__accuracy-bg-white">
              <span>{{iterate.accuracy_data.accuracy}}</span>
              <div class="auto-ml-results__progress auto-selected-tooltip">
                <img *ngIf="iterate.accuracy_data.accuracy==='High'" src="assets/images/svg/High-accuracy.svg" alt="">
                <img *ngIf="iterate.accuracy_data.accuracy==='Medium'" src="assets/images/svg/Medium-accuracy.svg" alt="" >
                <img *ngIf="iterate.accuracy_data.accuracy==='Low'" src="assets/images/svg/Low-accuracy.svg" alt="" >
                <div class="auto-ml-results__tooltip"> 
                  <div class="auto-ml-results__tooltip-txt">
                    RSME : 
                    <span>{{iterate.accuracy_data?.rmse_value|number:'1.1-1'}}</span>
                  </div>
                  <div class="auto-ml-results__tooltip-txt">
                    MAPE : 
                    <span>{{iterate.accuracy_data?.mape_value|number:'1.1-1'}}</span>
                  </div>
                  <div class="auto-ml-results__tooltip-txt">
                    R-SQUARED :
                    <span>{{iterate.accuracy_data?.R_value|number:'1.1-1'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="auto-ml-results__tile-contents">
            <div class="auto-ml-results__tile-desc">
              Selected Independent Variables
            </div>
            <div class="auto-ml-results__tags-outer">
  
              <span *ngFor="let item of iterate.compared_result" class="auto-ml-results__tag" [ngClass]="{'selected': item.selected,'alert-tag':item.remove && item.selected }">
                {{item.name}}
                <div *ngIf="item.remove && item.selected" class="auto-selected-tooltip">
                  <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Group 15742">
                    <g id="Group">
                    <path id="Vector" d="M8.25 9L12.4167 10.25L1.16666 20.25L5.75 11.9167L1.58333 10.25L12.4167 1.5L8.25 9Z" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <path id="Vector 635" d="M10.75 21.0833L13.6667 14L17.4167 21.0833" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path id="Vector 636" d="M12 18.583H16.1667" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    </svg>
                    <div class="auto-ml-results__tooltip">
                      Automatically excluded for low predictive value.
                  </div>
                </div>
                
                    <!-- <a *ngIf="item.remove && item.selected" href="javascript:void(0)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                      <path d="M8.18345 15.4665C11.8561 15.4665 14.8334 12.3475 14.8334 8.49987C14.8334 4.65229 11.8561 1.5332 8.18345 1.5332C4.51076 1.5332 1.53345 4.65229 1.53345 8.49987C1.53345 12.3475 4.51076 15.4665 8.18345 15.4665Z" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10.7083 6.12109L5.9668 10.8532" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10.7083 10.8532L5.9668 6.12109" stroke="#BA0202" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg></a> -->
                    
            </span>
            </div>
            <!-- <a href="javascript:void(0)" class="auto-ml-results__edit-variable">
              <img
                src="assets/images/svg/edit-icon-blue.svg"
                alt=""
              />
              Edit Variables
            </a> -->
          </div>
        </div>
      </div>
      <div class="auto-ml-results__colors-outer">
        <div class="auto-ml-results__color">
          <span></span> Selected Variables
        </div>
        <div class="auto-ml-results__color light-blue">
          <span></span> Unselected Variables
        </div>
        <div class="auto-ml-results__color red">
          <span></span> Automatically Ignored
        </div>
      </div>
      
    </div>
    <div class="auto-ml-results__right-sec" [ngClass]="{'auto-ml-results__right-sec-s': _autoMl.iterationSet[_autoMl.iterationSet.length - 1].target_columns.length ===0}">

      <div *ngIf="_autoMl.iterationSet[_autoMl.iterationSet.length - 1].target_columns.length ===0" class="auto-ml-results__multiple-itrations-view">
        <div class="auto-ml-results__itration-middle-sec">
          <div class="auto-ml-results__itration-middle-heading">
            Select the variables you want to include in the analysis
          </div>
          <div class="auto-ml-results__itration-mid-tagsouter">
            <a *ngFor="let item of _autoMl.iterationSet[_autoMl.selectedIndex].all_columns;let i=index"
            (click)="_autoMl.iterationSet[_autoMl.selectedIndex].all_columns[i].check = !_autoMl.iterationSet[_autoMl.selectedIndex].all_columns[i].check"
            [ngStyle]="{'background-color':!item.check ?'rgb(106 168 94 / '+getWidthCoValue(item.co_value,100)+'%)':''}"  
            [ngClass]="{'auto-ml-results--co-tag-white': getWidthCoValue(item.co_value,100)>69 ,'auto-ml-results--co-tag-border':getWidthCoValue(item.co_value,100)<4,'selected': item.check }" 
            class="auto-ml-results--co-tag auto-ml-results__tag " >
              {{item.name}}
            </a>
          </div>
          <div (click)="_autoMl.runIterationSet(_autoMl.selectedIndex);" class="auto-ml-results__run-btn " [ngClass]="{'po-none': _autoMl.iterationSet[_autoMl.selectedIndex].isRunLoad , 'disabled': !disableState}">
            Run Model
            <svg *ngIf="!_autoMl.iterationSet[_autoMl.selectedIndex].isRunLoad" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M10.5 19.6004C15.7651 19.6004 20.0333 15.5262 20.0333 10.5004C20.0333 5.4746 15.7651 1.40039 10.5 1.40039C5.23489 1.40039 0.966675 5.4746 0.966675 10.5004C0.966675 15.5262 5.23489 19.6004 10.5 19.6004Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.6656 10.6271L8.37527 14.2589L8.37527 6.99542L14.6656 10.6271Z" fill="white"/>
          </svg>
            <app-circle-loader *ngIf="_autoMl.iterationSet[_autoMl.selectedIndex].isRunLoad" color="white"></app-circle-loader>
          </div>
          <div class="auto-ml-results__bar-value">
            <p>Correlation Strength</p>
            <div class="color-bar">
              <div *ngFor="let item of arrays;let i=index" class="colors" [ngStyle]="{ background: 'rgb(106 168 94 / '+((100*(i))/5)+'%)'}">
              </div>
            </div>
            <div class="labels">
              <span>High</span>
              <span>Low</span>
            </div>
          </div>
        </div>

        <div *ngIf="_autoMl.iterationSet[_autoMl.selectedIndex].isRunLoad" class="auto-ml-page__loading-box">
          <div class="auto-ml-page__loading-card">
              <div class="auto-ml-page__loading-percent">
                <svg>
                  <circle cx="50%" cy="50%" r="23"></circle>
                  <circle cx="50%" cy="50%" r="23" [style]="'--percent:'+ _autoMl.value"></circle>
                </svg>
                <div class="auto-ml-page__loading-icon">
                  <img src="assets/images/svg/time-icon.svg" alt="">
                </div>
              </div>
          </div>
          <div class="auto-ml-page__loading-contents">
              
              <div class="auto-ml-page__loading-per" >
                  {{_autoMl.value+'%'}}
              </div>
              <div class="auto-ml-page__loading-txt">
                  <div [ngSwitch]="_autoMl.value">
                      {{_autoMl.loaderText}}
                  </div>
              </div>
          </div>
      </div>

      </div>
      <div *ngIf="_autoMl.iterationSet[_autoMl.iterationSet.length - 1].target_columns.length > 0" class="auto-ml-results__graph-view-outer">
          <div class="scad-tab-log__header">
            <div class="d-flex scad-tab-log__tabs">
              <div
                class="scad-tab-log__item"
                [ngClass]="{ active: typeOfIncome === 'Results' }"
                (click)="typeOfIncome = 'Results'"
              >
                Results
              </div>
              <div
                class="scad-tab-log__item"
                [ngClass]="{ active: typeOfIncome === 'Comparision' }"
                (click)="typeOfIncome = 'Comparision'"
              >
                Comparision
              </div>
            </div>
          </div>
        <div *ngIf="typeOfIncome === 'Comparision'">
          <ul class="tabs-new">
            <li [ngClass]="{'active': comparisonType==='importenceScore'}" (click)="comparisonType='importenceScore'">Importance Score 
            <div class="auto-selected-tooltip">
              <img src="../../../../../assets/images/svg/info.svg" alt="">
              <div  class="auto-ml-results__tooltip"> 1 unit increase in x variable will lead to increase of (no.) of units in y </div>
            </div>
            </li>
            <li [ngClass]="{'active': comparisonType==='ranks'}" (click)="comparisonType='ranks'">Ranks</li>
          </ul>
          <div class="auto-ml-results__graph-sec">
            <div class="auto-ml-results__graph-tab-sec">
              <!-- <div> -->
                <p>A measure expressing the relative impact of each feature in relation to the overall predictive outcome</p>
              <!-- </div>
              <div> -->
                <div  class="auto-ml-results__download-icon"><img  src="assets/images/svg/download-icon.svg" alt=""></div>
                <div class="scad-tab-log__header">
                  <div class="d-flex scad-tab-log__tabs">
                    <div [ngClass]="{'active': mode==='table'}" (click)="mode='table'" class="scad-tab-log__item"><svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.76251 1H1.1665V15.608H6.76251V1Z" stroke="#3267FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18.6664 1H6.7749V5.86584H18.6664V1Z" stroke="#3267FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18.6664 5.87695H6.7749V10.7428H18.6664V5.87695Z" stroke="#3267FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18.6664 10.7422H6.7749V15.608H18.6664V10.7422Z" stroke="#3267FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div [ngClass]="{'active': mode==='chart'}" (click)="mode='chart'" class="scad-tab-log__item">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.375 3.33398V21.6673H20.7917" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.1665 12.6035V16.666" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.9165 9.16602L12.9165 16.666" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M17.083 12.916L17.083 16.666" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              <!-- </div> -->
            </div>
            <div *ngIf="comparisonType==='importenceScore'" class="auto-ml-results__graph-display" [ngClass]="{'auto-ml-results--graph-table': mode==='table'}">
              <!-- for table view add this class "auto-ml-results--graph-table" to auto-ml-results__graph-display -->
              <div *ngIf="mode==='table'" class="auto-ml-results__graph-tile">
                <!-- if selected add this class "auto-ml-results--graph-selected" to auto-ml-results__graph-tile -->
                <div class="auto-ml-results__grptablename">
                  <p>Variables</p>
                </div>
                
               <div class="auto-ml-results__graph-progresswrap">
                <div *ngFor="let bar of _autoMl.comparisonImportenceScore[0].data" class="auto-ml-results__graph-progress-outer">
                  <div [matTooltip]="bar.name">{{bar.name}}</div>
                </div>
               </div>
                
              </div>
              <div *ngFor="let item of _autoMl.comparisonImportenceScore;let i=index" class="auto-ml-results__graph-tile" [ngClass]="{'auto-ml-results--graph-selected': _autoMl.selectedIndex === i}" (click)="_autoMl.selectedIndex = i">
                <!-- if selected add this class "auto-ml-results--graph-selected" to auto-ml-results__graph-tile -->
                <div class="auto-ml-results__graph-topsec">
                  <div class="scad-radio">
                    <label class="scad-title__sm-thin-gray2"><input type="radio" [checked]="_autoMl.selectedIndex === i" class="input-radio blue" name="chart"> <span class="auto-ml-results__graph-head">{{_autoMl.iterationSet[i].name}}</span> </label>
                  </div>
                  <div class="auto-ml-results__graph-accuracyouter">
                    <div class="auto-selected-tooltip">
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data.accuracy==='High'" src="assets/images/svg/High-accuracy.svg" alt="">
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data.accuracy==='Medium'" src="assets/images/svg/Medium-accuracy.svg" alt="" >
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data.accuracy==='Low'" src="assets/images/svg/Low-accuracy.svg" alt="" >
                      <div class="auto-ml-results__tooltip"> 
                        <div class="auto-ml-results__tooltip-txt">
                          RSME : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.rmse_value|number:'1.1-1'}}</span>
                        </div>
                        <div class="auto-ml-results__tooltip-txt">
                          MAPE : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.mape_value|number:'1.1-1'}}</span>
                        </div>
                        <div class="auto-ml-results__tooltip-txt">
                          R-SQUARED : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.R_value|number:'1.1-1'}}</span>
                        </div>
                      </div>
                    </div>                  
                    <div class="auto-ml-results__graph-accuracycontents">
                      <div class="auto-ml-results__graph-accuracy-txt">
                        Accuracy
                      </div>
                      <div class="auto-ml-results__graph-accuracy-value">
                        {{_autoMl.iterationSet[i].accuracy_data?.accuracy}}
                      </div>
                    </div>
                  </div>
                </div>
                
               <div class="auto-ml-results__graph-progresswrap">
                <div *ngFor="let bar of item.data" class="auto-ml-results__graph-progress-outer" [style]="mode==='table' ? getBackground(item.data,bar.value!=='-'?bar.value:0):''">
                  <div class="auto-ml-results__graph-v" [matTooltip]="bar.name">{{bar.name}}</div>
                  <div class="auto-ml-results__graph-progress">
                    <span [ngStyle]="{width: getWidth(bar.value,i)+'%'}"></span>                  
                    <div class="auto-ml-results__graph-value">{{bar.value}}</div>
                  </div>
                </div>
               </div>
                
              </div>
            </div>
            <div *ngIf="comparisonType==='ranks'" class="auto-ml-results__graph-display" [ngClass]="{'auto-ml-results--graph-table': mode==='table'}">

              <div *ngIf="mode==='table'" class="auto-ml-results__graph-tile" >
                <!-- if selected add this class "auto-ml-results--graph-selected" to auto-ml-results__graph-tile -->
                <div  class="auto-ml-results__grptablename">
                  <p>Variables</p>
                </div>
                
               <div class="auto-ml-results__graph-progresswrap">
                <div *ngFor="let bar of _autoMl.soreImportenceScore[0].data" class="auto-ml-results__graph-progress-outer">
                  <div [matTooltip]="bar.name">{{bar.name}}</div>
                </div>
               </div>
                
              </div>
              <div *ngFor="let item of _autoMl.soreImportenceScore;let i=index"   class="auto-ml-results__graph-tile" [ngClass]="{'auto-ml-results--graph-selected': _autoMl.selectedIndex === i}" (click)="_autoMl.selectedIndex = i">
                <!-- if selected add this class "auto-ml-results--graph-selected" to auto-ml-results__graph-tile -->
                <div class="auto-ml-results__graph-topsec">
                  <div class="scad-radio">
                    <label class="scad-title__sm-thin-gray2"><input type="radio" [checked]="_autoMl.selectedIndex === i" class="input-radio blue" name="chart"> <span class="auto-ml-results__graph-head">{{_autoMl.iterationSet[i].name}}</span> </label>
                  </div>
                  <div class="auto-ml-results__graph-accuracyouter">
                    <div class="auto-selected-tooltip">
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data?.accuracy==='High'" src="assets/images/svg/High-accuracy.svg" alt="">
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data?.accuracy==='Medium'" src="assets/images/svg/Medium-accuracy.svg" alt="" >
                      <img *ngIf="_autoMl.iterationSet[i].accuracy_data?.accuracy==='Low'" src="assets/images/svg/Low-accuracy.svg" alt="" >
                      <div class="auto-ml-results__tooltip"> 
                        <div class="auto-ml-results__tooltip-txt">
                          RSME : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.rmse_value|number:'1.1-1'}}</span>
                        </div>
                        <div class="auto-ml-results__tooltip-txt">
                          MAPE : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.mape_value|number:'1.1-1'}}</span>
                        </div>
                        <div class="auto-ml-results__tooltip-txt">
                          R-SQUARED : 
                          <span>{{_autoMl.iterationSet[i].accuracy_data?.R_value|number:'1.1-1'}}</span>
                        </div>
                      </div>
                    </div>                  
                    <div class="auto-ml-results__graph-accuracycontents">
                      <div class="auto-ml-results__graph-accuracy-txt">
                        Accuracy
                      </div>
                      <div class="auto-ml-results__graph-accuracy-value">
                        {{_autoMl.iterationSet[i].accuracy_data?.accuracy}}
                      </div>
                    </div>
                  </div>
                </div>
                
               <div class="auto-ml-results__graph-progresswrap" >
                <div *ngFor="let bar of item.data" class="auto-ml-results__graph-progress-outer" [style]="mode==='table' ? getBackground2(item.data,bar.value):''">
                  <div class="auto-ml-results__graph-v" [matTooltip]="bar.name">{{bar.name}}</div>
                  <div class="auto-ml-results__graph-progress" >
                    <span [ngStyle]="{width: getWidth2(bar.value,i)+'%'}"></span>
                    <div class="auto-ml-results__graph-value" >{{bar.value}}
                    </div>
                  </div>
                </div>
               </div>
                
              </div>

              <!-- <div *ngFor="let item of _autoMl.soreImportenceScore;let i=index" class="auto-ml-results__graph-tile">
                <div class="auto-ml-results__graph-head">{{_autoMl.iterationSet[i].name}}</div>
                <div *ngFor="let bar of item" class="auto-ml-results__graph-progress-outer">
                  <div class="auto-ml-results__graph-v">{{bar.name}}</div>
                  <div class="auto-ml-results__graph-progress">
                    <span [ngStyle]="{width: getWidth2(bar.value)+'%'}"></span>
                    <div class="auto-ml-results__graph-value">{{bar.value}}</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div *ngIf="typeOfIncome === 'Results'" class="scad-tab-log__body">
          <ul *ngIf="_autoMl.resultPreviewData.length >0" class="tabs-new">
            <li
              [ngClass]="{ active: _autoMl.selectedIndex === i }"
              (click)="_autoMl.selectedIndex = i"
              *ngFor="let item of _autoMl.resultPreviewData; let i = index"
            >
             <span >{{ item.name }}</span> 
            </li>
          </ul>
          <app-line-chart-html titlechart="Comparision of Ranks"  [barData]="getBarData" [maxValue]="getMaxValue" [groups]="getGroupData" [barwidth]="42"></app-line-chart-html>

          <div *ngIf="_autoMl.resultPreviewData.length >0;" class="scad-tab-log__table mt-5">
            <div class="table-wrapper">
              <table matSort (matSortChange)="sortData($event)">
                <tbody>
                  <tr>
                    <th matSortActive [mat-sort-header]="item" *ngFor="let item of getTableKey;let i=index" class="scad-tab-log__head-align">
                      {{ item==='Feature'?'Column':item }} 
                      <div *ngIf="i===2" class="auto-selected-tooltip"><img  src="../../../../../assets/images/svg/info.svg" alt=""><div  class="auto-ml-results__tooltip"> 1 unit increase in x variable will lead to increase of (no.) of units in y </div></div>
                    </th>
                  </tr>
                  <tr *ngFor="let item of getTableData; let i = index">
                    <td *ngFor="let key of getTableKey;let j=index">
                      <div class="data-cell">
                        {{ j===2 ? item[key]+'%' : item[key] }}
                      <div *ngIf="j===2" class="auto-selected-tooltip"><img  src="../../../../../assets/images/svg/info.svg" alt=""><div  class="auto-ml-results__tooltip"> {{'1 unit increase in '+item.Feature+' will lead to '+ (item['regression coefficient']> 0 ?'increase':'decrease')+' of '+(item['regression coefficient'] <0 ? (-1 * item['regression coefficient']): item['regression coefficient'])+' of units in '+_autoMl.dependentVariable}} </div></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <div class="pagination">
                <div class="row-count">
                  <p>Row per page</p>
                  <ng-select
                    [items]="pageArr"
                    [searchable]="false"
                    [clearable]="false"
                    [(ngModel)]="selectedPage"
                  ></ng-select>
                  <p>{{ "of " + _fb.previewData.length + " rows" }}</p>
                </div>
                <div class="row-pagination">
                  <svg
                    (click)="decriement()"
                    class="left"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <circle
                      cx="16"
                      cy="16"
                      r="16"
                      transform="matrix(-1 0 0 1 32 0)"
                      fill="#1847DF"
                    />
                    <path
                      d="M13 12.5L18 16.45L13 20.3571"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div class="number">{{ page }}</div>
                  <p>{{ "out of " + testData.length }}</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    (click)="incriement()"
                  >
                    <circle
                      cx="16"
                      cy="16"
                      r="16"
                      transform="matrix(-1 0 0 1 32 0)"
                      fill="#1847DF"
                    />
                    <path
                      d="M13 12.5L18 16.45L13 20.3571"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div> -->
          </div>
          
        </div>
      </div>
      <div *ngIf="_autoMl.iterationSet[_autoMl.iterationSet.length - 1].target_columns.length >0" class="auto-ml-results__btns-outer ">
        <a  (click)="satisfyResult()"
          href="javascript:void(0)"
          class="auto-ml-results__scad-btn auto-ml-results--scad-btn-primary"
        >
         I’m satisfied with the Result
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none" style="margin-left: 8px;">
            <path d="M8.93059 11.4625L13.833 6.56004L8.85807 1.59961" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.0113 6.53125H13.833" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <a *ngIf="_autoMl.iterationSet.length <4"
          href="javascript:void(0)"
          class="auto-ml-results__scad-btn auto-ml-results--scad-btn-secondary"
          (click)="_autoMl.addIterationSet()"
        >
          Re Analyze
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px;">
            <path d="M2.7666 3.16602V17.8327H16.6999" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.3999 10.584V13.834" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.3999 7.83398L10.3999 13.834" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.7334 10.834L13.7334 13.834" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        </a>
      </div>
    </div>
    <div *ngIf="_autoMl.iterationSet[_autoMl.selectedIndex].target_columns.length ===0" class="auto-ml-results__right-co-part">
      <ul  class="tabs-new p30">
        <li class="active">
         <span >Correlation Coefficient</span> 
        </li>
      </ul>

      <div class="content-sec">
        <div class="single-variable" *ngFor="let item of sortedOrder">
            <p>{{item.name}}</p>
            <div  *ngIf="item.co_value;else noValue"  class="content-bar">
              <div class="bar" [ngStyle]="{ width: getWidthCoValue(item.co_value,40)+'%', 'background-color':'rgb(106 168 94 / '+getWidthCoValue(item.co_value,100)+'%)'}" [ngClass]="{'bar-inverse': item.co_value < 0}">
                <span>{{item.co_value}}</span>
              </div>
              
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noValue>
  <span>___</span>
</ng-template>